import { Component, OnInit, OnDestroy } from '@angular/core';
import { NavController, App, NavParams } from 'ionic-angular';
import { User } from '../../providers/user/user';
import { CurrentUser } from '../../models/user.model';
import { EventInfoProvider } from '../../providers/event-info/event-info';

/**
 * Generated class for the BasePageComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'base-page',
    templateUrl: 'base-page.html',
})
export class BasePageComponent implements OnInit, OnDestroy {
    constructor(
        public app: App,
        public navCtrl: NavController,
        public userService: User,
        public navParams: NavParams,
    ) {

    }

    currentUser: CurrentUser;
    sessionId: string;

    ngOnInit() {
        this.canView();
        this.getCurrentUser();
    }

    ngOnDestroy() {
    }

    async canView() {
        let view = await this.userService.authenticated();
        this.redirect(view);
    }

    redirect(auth: boolean): void {
        if (!auth) {
            this.app.getRootNav().setRoot('WelcomePage');
        }
    }

    getCurrentUser(): void {
        this.currentUser = this.userService.currentUser();
    }

}



// WEBPACK FOOTER //
// ./src/components/base-page/base-page.ts